import { getReadableString } from "constraints/general";
import { IShow } from "@evennt-tech/api-v2-core";

const getDatePattern = (
  show?: Pick<IShow, "dateFormat">,
  withComma?: boolean
) => {
  return `${getReadableString({
    dateFormat: show?.dateFormat,
  }).toUpperCase()}${withComma ? "," : ""} HH:mm`;
};

export default getDatePattern;
